/**
 * @generated SignedSource<<ba88b0345862930e14aa1f8de7f78803>>
 * @relayHash ee33ebdbc2609fb80782f7a2b9f1c25f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e8d4745e81584beba889bad1f79c23694cbe33a1550ae5e17e4e52d9bfda5d31

import type { ConcreteRequest, Query } from 'relay-runtime';
export type UpgradeModalQuery$variables = {
  cloudId: string;
  isCollectionEnabled: boolean;
  productKey: string;
};
export type UpgradeModalQuery$data = {
  readonly tenantContexts: ReadonlyArray<{
    readonly entitlementInfo: {
      readonly entitlement?: {
        readonly relatesFromEntitlements?: ReadonlyArray<{
          readonly relationshipType: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
};
export type UpgradeModalQuery = {
  response: UpgradeModalQuery$data;
  variables: UpgradeModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isCollectionEnabled"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productKey"
},
v3 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "cloudIds.0",
        "variableName": "cloudId"
      }
    ],
    "kind": "ListValue",
    "name": "cloudIds"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "hamsProductKey",
    "variableName": "productKey"
  }
],
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "CcpEntitlementRelationship",
      "kind": "LinkedField",
      "name": "relatesFromEntitlements",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "relationshipType"
        }
      ]
    }
  ],
  "type": "CcpEntitlement"
},
v6 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "UpgradeModalQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v4/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              {
                "condition": "isCollectionEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "entitlement",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "UpgradeModalQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v4/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "condition": "isCollectionEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "entitlement",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v5/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "e8d4745e81584beba889bad1f79c23694cbe33a1550ae5e17e4e52d9bfda5d31",
    "metadata": {},
    "name": "UpgradeModalQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "c22a3f7e50fc3037dc20c2ccbf45da66";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
